import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* -------------------- ALL Orders -------------------- */
export const AllOrdersThunk = createAsyncThunk(
  "orders/AllOrdersThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/admin/orders/list?order_status=confirmed`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch orders");
    }
  }
);

/* -------------------- GET SINGLE Order -------------------- */
export const GetSingleOrdersThunk = createAsyncThunk(
  "orders/GetSingleOrdersThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/admin/orders/show?uuid=${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch order details");
    }
  }
);

/* -------------------- ADD Order -------------------- */
export const AddOrdersThunk = createAsyncThunk(
  "orders/AddOrdersThunk",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/orders/add`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to add order");
    }
  }
);

/* -------------------- UPDATE Order -------------------- */
export const UpdateOrdersThunk = createAsyncThunk(
  "orders/UpdateOrdersThunk",
  async ({ uuid, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/orders/update`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update order");
    }
  }
);

/* -------------------- DELETE Order -------------------- */
export const DeleteOrdersThunk = createAsyncThunk(
  "orders/DeleteOrdersThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/admin/orders/delete?uuid=${uuid}`);
      return {
        uuid,
        message: response.data?.message || "Deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to delete order");
    }
  }
);

/* -------------------- GET SINGLE INVOICE -------------------- */
export const GetSingleOrdersInvoiceThunk = createAsyncThunk(
  "orders/GetSingleOrdersInvoiceThunk",
  async (order_no, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/invoices/generate/${order_no}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch order details");
    }
  }
);

